import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../../commons/app-commons.module';
import { WjCoreModule } from '@grapecity/wijmo.angular2.core';
import { ImgaeInfoRenderComponent } from './image-info-renderer.component';


/**
 * 画像表示 モジュール設定クラス
 *
 * @export ImgaeInfoRenderModule
 * @class ImgaeInfoRenderModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjCoreModule
  ],
  declarations: [
    ImgaeInfoRenderComponent,
  ],
  providers: [
  ],
  exports: [
    ImgaeInfoRenderComponent,
  ]
})
export class ImgaeInfoRenderModule {

}
